import { InjectionToken } from '@angular/core';

export const APP_TARGET = new InjectionToken<string>('AppTarget');
export const OFFLINE_MODE = new InjectionToken<boolean>('OfflineMode');
export const ACCEPT_COOKIES_ENABLED = new InjectionToken<boolean>('AcceptCookiesEnabled');
export const SERVICE_DESK_URL = new InjectionToken<string>('ServiceDeskUrl');
export const FAQ_URL_EN = new InjectionToken<string>('FaqUrlEn');
export const FAQ_URL_FR = new InjectionToken<string>('FaqUrlFr');
export const WEBSITE_URL = new InjectionToken<string>('WebsiteUrl');
